<app-parcels-preview
  (onEdit)="showItemForm = true; parcelItemForm.patchValue($event.v); currentIndex = $event.i"
  (onRemove)="onRemoveItem($event)"
  [showActions]="!disabled"
  [canEdit]="(currentIndex === undefined) && !showItemForm"
  [parcels]="parcels()">
</app-parcels-preview>
@if (showItemForm) {
  <br>
  <div class="row">
    <app-parcel-item-form
      [showCancel]="!!parcels().length"
      [edit]="currentIndex != undefined"
      [form]="parcelItemForm"
      (submit)="onSubmitItemForm($event)"
      (cancel)="onCancelItemForm()">
    </app-parcel-item-form>
  </div>
}
<br>
<div class="row" *ngIf="!showItemForm && !disabled">
  <div class="col-12 d-flex justify-content-end">
    <button class="btn btn-primary" type="button" (click)="showItemForm = true">
      {{ parcels().length ? 'Dodaj kolejną' : 'Dodaj działkę' }}
    </button>
  </div>
</div>
<br>
